import { ModalBase } from '../../../../components/Modals/ModalBase'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import { State } from '../../../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actionsDocumentos } from '../../../../actions/action-creators'
import { docsAsociadosItems } from './OtrosDocAsociados'

const ModalDocsAsociados = (props: any) => {
  const {formDoc, errorDoc, dataDocsAsociados} = useSelector((state: State) => state.documentos.otrosDocumentosAsociados)
  const dispatch = useDispatch();
  const {docsSetDocsAsociados, docsFormHandleChangeInput} = bindActionCreators(actionsDocumentos, dispatch);

  const handleChangeForm = (e: any) => {
    docsFormHandleChangeInput(e);
  }

  const handleActionDoc = () => {
    if (!formDoc.descripcion || !formDoc.tipo || !formDoc.identificacion) return;
    if (formDoc.mode == "add") {
      docsSetDocsAsociados([...dataDocsAsociados, {...formDoc, id: Math.floor(Math.random() * 900000) + 100000}]);
    } else {
      docsSetDocsAsociados(dataDocsAsociados.map((doc: any) => (doc.id === formDoc.id) ? formDoc : doc));
    }
    props.onCancel();
  }

  return (
    <ModalBase>
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
        <div className='card w-form'>
          <form className='form-content'>
            <div>
              <h3 className='card-title l'>Información del documento asociado</h3>
              <div className='form-separator'></div>
            </div>
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='tipo' className='field-label m'>
                  Documento asociado<span style={{color: 'red'}}>*</span>
                </label>
                <SearchSelect
                  data={docsAsociadosItems}
                  keyNameText='valor'
                  keyNameValue='codigo'
                  placeholder='Unidad de medida'
                  name='tipo'
                  disabled = {false}
                  placement='bottom'
                  value={formDoc.tipo}
                  onChange={(e) => handleChangeForm({target: {value: e.value, name: 'tipo'}})}
                />
                {/* {errors.tipoDescuento ? (<p className='alert s'>{errors.tipoDescuento}</p>) : errors.cantidad || errors.precio || errors.descuento ? (<p className='alert s'>&nbsp;</p>) : ('')} */}
              </div>
            </div>
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='identificacion' className='field-label m'>
                  Identificación del documento<span style={{color: 'red'}}>*</span>
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='identificacion'
                  data-name=''
                  placeholder='Identificación del nombre del documento asociado'
                  id='identificacion'
                  maxLength={100}
                  value={formDoc.identificacion}
                  onChange={handleChangeForm}
                />
                {/* {errors.descripcion && <p className='alert s'>{errors.descripcion}</p>} */}
              </div>
            </div>
            <div className='w-layout-hflex h-inputs'>
              <div className='label-input'>
                <label htmlFor='descripcion' className='field-label m'>
                  Descripción del documento<span style={{color: 'red'}}>*</span>
                </label>
                <input
                  autoComplete='off'
                  type='text'
                  className='m text-field w-input'
                  name='descripcion'
                  data-name=''
                  placeholder='Descripción de datos importantes del documento asociado'
                  id='descripcion'
                  maxLength={100}
                  value={formDoc.descripcion}
                  onChange={handleChangeForm}
                />
                {/* {errors.descripcion && <p className='alert s'>{errors.descripcion}</p>} */}
              </div>
            </div>
            <div className='w-layout-hflex button-actions' style={{marginTop: '8px'}}>
              <button type='button' className='m button transparent w-inline-block' onClick={() => props.onCancel()}>
                <div>Cancelar</div>
              </button>
              <button type='button' onClick={handleActionDoc} className='m button w-inline-block'>
                <div>{formDoc.mode === "add" ? 'Agregar' : 'Actualizar'}</div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalDocsAsociados
